/**
 * src/linkSearch.js
 *
 * Booking Links list search: every word typed must match the link's topic,
 * link id, booking URL, description or status. Words can be in any order
 * ("expert staging" finds "Website Talk to an Expert (Staging)"). "active" /
 * "inactive" match the status exactly, so "active" doesn't also return
 * inactive links.
 *
 * URLs: links are stored as "/mek/<ID>?utm_…" but shown with the site
 * address in front, so a pasted full URL (from any environment) has its
 * "https://host" stripped before matching. Part of a URL or just the unique
 * ID matches too, and "Talk to an Expert" matches the encoded
 * "Talk+to+an+Expert" in a UTM value.
 */

const STATUS_WORDS = new Set(["active", "inactive"]);

export const linkStatusLabel = (link) => (link?.mek_linkstatus !== 0 ? "Active" : "Inactive");

function decoded(url) {
  try { return decodeURIComponent(url.replace(/\+/g, " ")); } catch { return url; }
}

export function matchesLinkSearch(link, query) {
  const words = String(query || "").toLowerCase().split(/\s+/)
    .map((w) => w.replace(/^https?:\/\/[^/]*/, "")) // a pasted full URL → its "/mek/…" part
    .filter(Boolean);
  if (!words.length) return true;
  const status = linkStatusLabel(link).toLowerCase();
  const url = String(link?.mek_url || "");
  const text = [link?.mek_displayname, link?.mek_linkid, url, decoded(url), link?.mek_description]
    .map((v) => String(v || "").toLowerCase())
    .join(" ");
  return words.every((w) => (STATUS_WORDS.has(w) ? status === w : text.includes(w) || status.includes(w)));
}
